import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Category } from 'src/app/models/category';
import { ModalController, IonSelect } from '@ionic/angular';
import { UiUtils } from 'src/app/util/ui-utils';
import { TranslateService } from '@ngx-translate/core';
import {Shop} from '../../models/shop';
import {ShopService} from '../../services/shop.service';

@Component({
  selector: 'app-category-add-edit-modal',
  templateUrl: './category-add-edit-modal.component.html',
  styleUrls: ['./category-add-edit-modal.component.scss'],
})
export class CategoryAddEditModalComponent implements OnInit {

  @Input() category: Category;

  categoryBeforeChanges: Category;
  mode: 'adding'|'editing' = 'editing';

  restaurant: Shop;

  @ViewChild('ionSelect', {static: true}) ionSelect: IonSelect;

  constructor(
    private modalController: ModalController,
    private uiUtils: UiUtils,
    private translateService: TranslateService,
    private shopService: ShopService
  ) { }

  ngOnInit() {
    if (!this.category) {
      this.category = new Category();
      this.mode = 'adding';
    }

    this.categoryBeforeChanges = {...this.category};

    this.shopService.getCurrentShop().subscribe(shop => this.restaurant = shop);
  }

  async dismissSelfWithData() {
    const formValidation = this.getFormValidation();
    if (!formValidation.isValid) {
      return this.uiUtils.showConfirmAlert(this.translateService.instant('generic.invalidField'),
          formValidation.errorMsg, this.translateService.instant('generic.accept'));
    }

    this.modalController.dismiss({ category: this.category });
  }

  dismissSelfWithoutData() {
    if (!this.hasChanged()) { return this.modalController.dismiss(); }

    this.uiUtils.showAlert('', this.translateService.instant('generic.exitWithoutSave'), '', [
      { text: this.translateService.instant('generic.save'), handler: () => this.dismissSelfWithData() },
      { text: this.translateService.instant('generic.dontSave'), handler: () => this.modalController.dismiss() },
      { text: this.translateService.instant('generic.cancel') }
    ]);
  }

  deleteSelf() {
    const secondConfirmation = () => {
      this.uiUtils.showConfirmAlert(
        this.translateService.instant('generic.areYouSure'),
        this.translateService.instant('component.category_add_edit_modal.message.permanentAction'),
        this.translateService.instant('generic.accept'), () => this.modalController.dismiss({ categoryToRemove: this.category }),
        this.translateService.instant('generic.cancel')
      );
    };

    const firtConfirmation = () => {
      this.uiUtils.showConfirmAlert(
        this.translateService.instant('component.category_add_edit_modal.message.confirmDelete'),
        this.translateService.instant('component.category_add_edit_modal.message.permanentAction'),
        this.translateService.instant('generic.accept'), () => secondConfirmation(),
        this.translateService.instant('generic.cancel')
      );
    };

    firtConfirmation();
  }

  private hasChanged() {
    if (this.categoryBeforeChanges.name !== this.category.name) { return true; }
    if (this.categoryBeforeChanges.weekday !== this.category.weekday) { return true; }

    return false;
  }

  private getFormValidation() {
    let isValid = true;
    let errorMsg: string;

    if (!this.category.name) { errorMsg = this.translateService.instant('component.category_add_edit_modal.message.categoryName'); }
    // tslint:disable-next-line:max-line-length
    if (!this.category.weekday === undefined) { errorMsg = this.translateService.instant('component.category_add_edit_modal.message.dayRequired'); }

    isValid = errorMsg ? false : true;
    return {isValid, errorMsg};
  }
}
